import * as React from 'react';
import ReactDOM from 'react-dom';
import Main from './screens/main';

ReactDOM.render(
    <Main />,
    document.getElementById('root')
);